import type { RouteLocationRaw } from "vue-router";

export const RouteName = "TournamentTeamListing.main"

export function routeDetailToRouteLocation() : RouteLocationRaw {
  return {name: RouteName}
}
